/**
 * GraphEdge — Weighted, typed, directional edge between nodes.
 */

import React from 'react';
import { RELATIONSHIP_TYPES } from './constants';
import type { SimNode } from './types';
import type { IntegrationEdge } from '../../services/integration-map-api';

interface Props {
  edge: IntegrationEdge;
  source: SimNode;
  target: SimNode;
  highlighted: boolean;
  dimmed: boolean;
  onMouseEnter: (e: React.MouseEvent, edge: IntegrationEdge) => void;
  onMouseLeave: () => void;
}

const GraphEdge: React.FC<Props> = ({ edge, source, target, highlighted, dimmed, onMouseEnter, onMouseLeave }) => {
  const type = RELATIONSHIP_TYPES[edge.relationshipType as keyof typeof RELATIONSHIP_TYPES]
    || RELATIONSHIP_TYPES.custom;
  const thickness = Math.max(1, edge.weight / 2);
  const opacity = dimmed ? 0.08 : highlighted ? 1 : 0.6;

  return (
    <line
      x1={source.x}
      y1={source.y}
      x2={target.x}
      y2={target.y}
      stroke={type.color}
      strokeWidth={highlighted ? thickness + 1 : thickness}
      strokeDasharray={type.dash || undefined}
      opacity={opacity}
      markerEnd="url(#arrow)"
      style={{ cursor: 'pointer', transition: 'opacity 0.2s' }}
      onMouseEnter={(e) => onMouseEnter(e, edge)}
      onMouseLeave={onMouseLeave}
    />
  );
};

export default GraphEdge;
